const map = new WeakMap()

const callback = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const callback = map.get(entry.target)
      callback()
      observer.unobserve(entry.target)
    }
  });
}

const observer = new IntersectionObserver(callback, { rootMargin: "100px" }) // 100px above visible part

const registry = (element, callback) => {
  map.set(element, callback)
  observer.observe(element)
}

const unregistry = (element) => {
  if (map.has(element)) {
    map.delete(element)
  }
 
  if (element && element.target) {
    observer.unobserve(element.target)
  }

}

export { registry, unregistry }